import { Notify } from 'quasar'
import { Filesystem, Directory } from '@capacitor/filesystem'
import { FileOpener } from '@capawesome-team/capacitor-file-opener'

/**
 * Download a PDF to the cache, then hand it to the OS: Quick Look on iOS,
 * whatever handles PDFs on Android. The native side fetches it, so the file
 * never passes through JS as a base64 string. Quick Look's Done returns to
 * the page that opened it, which an in-app browser's close button does not.
 *
 * @param url  Where to fetch the file from.
 * @param path Cache-relative path to store it at. Overwritten on each call.
 * @returns {Promise<boolean>} Whether the file was opened.
 */
export async function openPdfNatively (url, path) {
  try {
    const result = await Filesystem.downloadFile({
      url,
      path,
      directory: Directory.Cache,
      recursive: true
    })
    await FileOpener.openFile({ path: result.path, mimeType: 'application/pdf' })
    return true
  }
  catch (err) {
    console.error('failed to open file in the device viewer', err)
    Notify.create({
      color: 'red',
      message: 'Could not open the file on this device'
    })
    return false
  }
}
